/**
 * "Frying" icon by ahmadwil from the Noun Project.
 * - Source: https://thenounproject.com/browse/icons/term/frying/
 * - License: Creative Commons Attribution (CC BY 3.0)
 * - License URL: https://creativecommons.org/licenses/by/3.0/
 */
import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const FryingIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      // viewBox="-5.0 -10.0 110.0 135.0"
      viewBox="0 0 100 100">
      <path d="m71.125 51.043c-9.6367-4.1133-19.332-6.3789-26.762-6.3789-7.3789-0.19141-15.723 2.8555-10.629 11.41 3.5547 6.7109 16.902 15.727 26.832 19.695 18.047 7.7109 35.703 8.5586 38.566 1.8594 2.543-5.9805-8.1016-18.074-28.008-26.586zm21.68 21.98c-0.49219 0.35547-1.2188 0.23047-1.5664-0.26953-8-12.148-35.91-24.02-50.09-21.191-1.4336 0.22656-1.8477-1.9609-0.37109-2.2344 15.008-2.9727 43.828 9.2891 52.297 22.129 0.35938 0.50781 0.23438 1.207-0.26953 1.5664zm3.6836 9.7969c-2.9219 4.9336-7.5 9.7773-13.617 9.6172-7.5312-0.011719-17.27-2.3438-26.719-6.3789-9.4453-4.0352-17.844-9.457-23.109-14.938-4.3047-4.2383-3.9609-10.973-2.4219-16.449 7.4258 17.652 47.957 34.953 65.867 28.148zm-65.25-35.871-29.59-32.309c-2.5625-2.4883-0.51953-7.207 3.0312-7.0781 1.2695-0.015625 2.4805 0.5625 3.293 1.5664l28.598 34.316c-2.0312 0.68359-4.0352 1.7383-5.332 3.5039z" />
    </SvgIcon>
  );
};

export default FryingIcon;
